module.exports = __webpack_public_path__ + "media/images/crime-trends-california-2023-e81370432a1819a8187627664c285397.png";